module.exports = __webpack_public_path__ + "img/logo-simplyhealth-new.05e2f2c0.svg";